<template>
  <BaseModal
    id="auth-modal"
    :hide-overflow="false"
    :modal-name="name"
    max-width="max-w-7xl"
    paddings-class="p-0"
  >
    <div class="flex flex-col bg-background md:flex-row">
      <form
        id="login-form"
        class="w-full bg-white px-5 py-8 shadow-md md:w-1/2 md:px-20 md:py-16"
        @submit.prevent="onSubmitLoginForm"
      >
        <h5
          class="mb-5 text-lg font-medium text-primary md:text-center md:text-2xl"
        >
          {{ $t('auth.login_on_patient_account') }}
        </h5>

        <div class="mt-10 w-full">
          <BaseFormInput
            v-model:value="form.email"
            :errors="authStore.errors"
            :is-required="true"
            :label="$t('auth.email')"
            name="email"
            autocomplete="username"
          />
        </div>
        <div class="mt-8 w-full">
          <BaseFormInput
            v-model:value="form.password"
            :errors="authStore.errors"
            :is-required="true"
            :label="$t('auth.password')"
            :toggle-show-button="true"
            name="password"
            type="password"
            autocomplete="current-password"
          />
        </div>
        <p class="text-right text-primary">
          <NuxtLink
            :to="useGenerateSharedURL('password/email')"
            class="cursor-pointer text-sm font-medium -tracking-[0.02rem] text-primary underline-offset-2 hover:underline hover:brightness-50"
          >
            {{ $t('auth.not_remember_password') }}
          </NuxtLink>
        </p>
        <div class="mt-12 flex w-full flex-row justify-center">
          <BaseButton
            id="sign_in-button"
            class="w-[300px]"
            theme="primary"
            type="submit"
          >
            {{ $t('auth.sign_in') }}
          </BaseButton>
        </div>
      </form>

      <div class="flex w-full flex-col px-5 py-8 md:w-1/2 md:px-20 md:py-16">
        <h5 class="mb-5 text-left text-lg font-medium text-primary md:text-2xl">
          {{ $t('auth.dont_have_a_patient_account_create_one') }}
        </h5>

        <p class="pb-4 text-sm text-primary md:text-base">
          {{ $t('auth.your_benefits') }}:
        </p>

        <div class="flex flex-col lg:flex-row">
          <ul
            class="mb-3 ml-3 w-full list-disc space-y-3 text-sm font-medium text-primary lg:mb-8 lg:w-1/2"
          >
            <li>{{ $t('auth.benefits.benefit_one') }}</li>
            <li>{{ $t('auth.benefits.benefit_two') }}</li>
            <li>{{ $t('auth.benefits.benefit_three') }}</li>
          </ul>
          <ul
            class="mb-8 ml-3 w-full list-disc space-y-3 text-sm font-medium text-primary lg:w-1/2"
          >
            <li>{{ $t('auth.benefits.benefit_fife') }}</li>
          </ul>
        </div>

        <NuxtLink
          :to="useGenerateSharedURL(registerURL)"
          class="flex w-full lg:w-[300px]"
        >
          <BaseButton id="register-button" class="w-full" theme="primary">
            {{ $t('auth.create_account') }}
          </BaseButton>
        </NuxtLink>

        <h5
          class="mb-5 mt-10 text-left text-lg font-medium text-primary md:text-2xl"
        >
          {{ $t('auth.purchase_without_registration') }}
        </h5>

        <p class="pb-8 text-sm text-primary md:text-base">
          {{ $t('auth.buy_as_a_guest') }}
        </p>

        <BaseButton
          id="continue-button"
          class="w-full self-start lg:w-[300px]"
          theme="white"
          @click="onClickContinue"
        >
          {{ $t('action.continue') }}
        </BaseButton>
      </div>
    </div>
  </BaseModal>
</template>

<script setup>
import { useAuthRoutes } from '~/composables/useAuthRoutes'
import { useModalsStore } from '~/stores/modals'
import { useAuthStore } from '~/stores/auth'
import { useAppStore } from '~/stores/app'

const name = 'authModal'

const { registerURL } = useAuthRoutes()
const modalStore = useModalsStore()
const authStore = useAuthStore()
const appStore = useAppStore()

const getClearFormData = () => {
  return {
    email: '',
    password: '',
  }
}

const form = ref(getClearFormData())

const onSubmitLoginForm = async () => {
  appStore.startLoading()
  try {
    const data = await authStore.login(form.value)

    if (data.type === 'old_system') {
      window.location = useGenerateSharedURL('login/migration-type')
    } else {
      form.value = getClearFormData()
      modalStore.close(name)
      appStore.stopLoading()
    }
  } catch (error) {
    appStore.stopLoading()
  }
}
const onClickContinue = () => {
  modalStore.close(name)
  modalStore.open('addCurrentPatientModal')
}
</script>
